import { ServiceWithPricing, EquipmentQuantity } from '@/util/types/serverTypes';

/**
 * Extracts equipment adjustments from services' modifier calculations
 * 
 * Modifiers can specify equipment needs (e.g., "add 2 radon canisters if sqft > 3000")
 * This function collects all those adjustments into a flat array
 * 
 * @param services - Services with calculated pricing and modifiers
 * @returns Flattened array of equipment adjustments from all services
 */
export function extractEquipmentAdjustments(
  services: ServiceWithPricing[]
): EquipmentQuantity[] {
  return services
    .map((service) =>
      service.modifierCalc && 'equipmentAdjustments' in service.modifierCalc
        ? service.modifierCalc.equipmentAdjustments
        : []
    )
    .flat() as EquipmentQuantity[];
}

